package com.karawek.core.auth.di

import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.model.AuthSession
import com.karawek.core.platform.PlatformContext
import com.karawek.core.platform.SecureStorage
import com.karawek.core.platform.createSecureStorage
import kotlinx.coroutines.flow.Flow
import me.tatarka.inject.annotations.Provides
import me.tatarka.inject.annotations.Qualifier
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesTo
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Qualifier annotation class AuthSessionStorage

@ContributesTo(AppScope::class)
interface AuthModule {

    @SingleIn(AppScope::class)
    @Provides
    @AuthSessionStorage
    fun provideAuthSessionStore(
        context: PlatformContext,
    ): SecureStorage =
        createSecureStorage(context = context, name = "auth_session")
}
